/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
  Label,
} from "reactstrap";

import { withTranslation } from "react-i18next";

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import Breadcrumbs from "../../components/Common/Breadcrumb";

import { isArray } from "../../Libs/CustomMethods/customMethods";

import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";

import schema from "./GoalValidation.js";

import Select from "react-select";

import TextareaAutosize from "react-textarea-autosize";

import {
  getGoal,
  createGoal,
  editGoal,
  resetGoal,
  resetGoals,
  resetError,
} from "../../store/goals/actions";

const NewGoal = ({ t }) => {
  let { idGoal } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { register, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const {
    dataGoalGetSet,
    dataGoalEditCreate,
    loadingGoal,
    loadingGoalEditCreate,
    successGoal,
    errorGoal,
  } = useSelector((state) => state.Goals);

  const [newFields, setNewFields] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);

  const [goalValues, setGoalValues] = useState({
    name: "",
    nameBk: "",

    group: "",
    groupBk: "",

    type: "",
    typeBk: "",

    value: "",
    valueBk: "",

    tooltip: "",
    tooltipBk: "",
  });

  const showToast = useCallback(
    (type, message) => {
      toastr[type](message);
    },
    [successGoal]
  );
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successGoal &&
      dispatch(resetGoal()) &&
      dispatch(resetGoals()) &&
      history.push("/goals"),
  };

  const handleCreateEditGoal = () => {
    if (idGoal) {
      dispatch(editGoal(idGoal, newFields));
    } else {
      dispatch(createGoal(newFields));
    }
  };

  const checkInput = (target, values, valuesBk) => {
    if (values === valuesBk) {
      delete newFields[target];
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        [target]: values,
      });
    }
  };

  const optionsGroups = () => {
    let groups = [];

    if (dataGoalGetSet?.data?.form?.groups?.length > 0) {
      dataGoalGetSet.data.form.groups.map((group) =>
        groups.push({
          key: group.id,
          value: group.id,
          label: group.name,
        })
      );
    } else {
      if (loadingGoal) {
        groups.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      } else {
        groups.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    return groups;
  };

  const optionsTypes = () => {
    let types = [];

    if (dataGoalGetSet?.data?.form?.goal?.type?.length > 0) {
      dataGoalGetSet.data.form.goal.type.map((type) =>
        types.push({
          key: type,
          value: type,
          label: t(type),
        })
      );
    } else {
      if (loadingGoal) {
        types.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      } else {
        types.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    return types;
  };

  const checkSubmit = () => {
    if (Object.keys(newFields).length > 0) setEnableSubmit(true);
    else setEnableSubmit(false);
  };

  useEffect(() => {
    if (idGoal) {
      dispatch(getGoal(idGoal, true));
    } else {
      dispatch(getGoal(null, true));
    }
  }, []);

  useEffect(() => {
    if (idGoal && dataGoalGetSet?.data && !loadingGoal) {
      setValue("goalGroup", dataGoalGetSet.data?.group_id, {
        shouldValidate: true,
      });
      setValue("goalType", dataGoalGetSet.data?.type, { shouldValidate: true });
      setGoalValues({
        ...goalValues,
        name: dataGoalGetSet.data?.name,
        nameBk: dataGoalGetSet.data?.name,

        group: dataGoalGetSet.data?.group_id,
        groupBk: dataGoalGetSet.data?.group_id,

        type: dataGoalGetSet.data?.type,
        typeBk: dataGoalGetSet.data?.type,

        value: dataGoalGetSet.data?.value,
        valueBk: dataGoalGetSet.data?.value,

        tooltip: dataGoalGetSet.data?.tooltip,
        tooltipBk: dataGoalGetSet.data?.tooltip,
      });
    }
  }, [dataGoalGetSet]);

  useEffect(() => {
    if (dataGoalEditCreate?.message) {
      showToast("success", t(dataGoalEditCreate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successGoal]);

  useEffect(() => {
    if (isArray(errorGoal) && errorGoal?.length > 0) {
      errorGoal.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorGoal) {
        showToast("error", t(errorGoal));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorGoal]);

  useEffect(() => {
    checkSubmit();
  }, [newFields]);

  const setClassName = (errors, classname) => {
    return errors ? "av-invalid is-invalid " + classname : classname;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/goals"
            path={"/goal"}
            title={t("Goals")}
            breadcrumbItem={idGoal ? t("Edit Goal") : t("Create goal")}
          />
          <Row>
            <Col xs="12" className="customContent">
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit(handleCreateEditGoal)}>
                    <Row className="mb-3">
                      <Col lg="6">
                        <Row>
                          <Col xs="12">
                            <FormGroup>
                              <Label id="goal-name-label">
                                {t("Name") + " *"}
                              </Label>
                              <input
                                type="text"
                                name="goalName"
                                ref={register}
                                className={setClassName(
                                  errors.goalName,
                                  "form-control"
                                )}
                                placeholder={t("Enter goal name")}
                                onChange={(e) => {
                                  setGoalValues({
                                    ...goalValues,
                                    name: e.target.value,
                                  });
                                  checkInput(
                                    "name",
                                    e.target.value,
                                    goalValues.nameBk
                                  );
                                }}
                                defaultValue={goalValues.name}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.goalName?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12">
                            <FormGroup className="select2-container">
                              <Label id="goals-type">{t("Type") + " *"}</Label>

                              <Select
                                id="goaltype"
                                name="goalType"
                                ref={() => register({ name: "goalType" })}
                                classNamePrefix="select2-selection"
                                className={setClassName(
                                  errors.goalType,
                                  " select2-selection"
                                )}
                                placeholder={t("Choose") + "..."}
                                options={optionsTypes()}
                                onChange={(e) => {
                                  setGoalValues({
                                    ...goalValues,
                                    type: e,
                                  });
                                  setValue("goalType", e?.value, {
                                    shouldValidate: true,
                                  });
                                  checkInput(
                                    "type",
                                    e?.value,
                                    goalValues.typeBk
                                  );
                                }}
                                value={optionsTypes().find(
                                  (e) => e.value === goalValues.type
                                )}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.goalType?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12">
                            <FormGroup>
                              <Label id="goal-value-label">
                                {t("Value") + " *"}
                              </Label>
                              <input
                                type="text"
                                name="goalValue"
                                ref={register}
                                className={setClassName(
                                  errors.goalValue,
                                  "form-control"
                                )}
                                placeholder={t("Enter goal value")}
                                onChange={(e) => {
                                  setGoalValues({
                                    ...goalValues,
                                    value: e.target.value,
                                  });
                                  checkInput(
                                    "value",
                                    e.target.value,
                                    goalValues.valueBk
                                  );
                                }}
                                defaultValue={goalValues.value}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.goalValue?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12">
                            <FormGroup className="select2-container">
                              <Label id="goals-group">
                                {t("Group") + " *"}
                              </Label>

                              <Select
                                id="goalgroup"
                                name="goalGroup"
                                ref={() => register({ name: "goalGroup" })}
                                classNamePrefix="select2-selection"
                                className={setClassName(
                                  errors.goalGroup,
                                  " select2-selection"
                                )}
                                placeholder={t("Choose") + "..."}
                                options={optionsGroups()}
                                onChange={(e) => {
                                  setGoalValues({
                                    ...goalValues,
                                    group: e,
                                  });
                                  setValue("goalGroup", e?.value, {
                                    shouldValidate: true,
                                  });
                                  checkInput(
                                    "group_id",
                                    e?.value,
                                    goalValues.groupBk
                                  );
                                }}
                                value={optionsGroups().find(
                                  (e) => e.value === goalValues.group
                                )}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.goalGroup?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12">
                            <FormGroup>
                              <Label id="goal-tooltip-label">
                                {t("Tooltip") + " *"}
                              </Label>
                              <div className="textarea-container">
                                <TextareaAutosize
                                  type="textarea"
                                  name="goalTooltip"
                                  ref={register}
                                  className={setClassName(
                                    errors.goalTooltip,
                                    "form-control"
                                  )}
                                  placeholder={t("Enter goal tooltip")}
                                  onChange={(e) => {
                                    setGoalValues({
                                      ...goalValues,
                                      tooltip: e.target.value,
                                    });
                                    checkInput(
                                      "tooltip",
                                      e.target.value,
                                      goalValues.tooltipBk
                                    );
                                  }}
                                  defaultValue={goalValues.tooltip}
                                />
                                <div id="textCopy"></div>
                              </div>
                              <div className="invalid-feedback d-block">
                                {t(errors.goalTooltip?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Button
                      type="submit"
                      color="primary"
                      className="mr-1 waves-effect waves-light"
                      style={{
                        minWidth: "100px",
                        cursor: enableSubmit ? "pointer" : "no-drop",
                      }}
                      disabled={!enableSubmit}
                    >
                      {loadingGoalEditCreate ? (
                        <Spinner
                          size="sm"
                          animation="border"
                          style={{
                            height: "19px",
                            width: "19px",
                          }}
                        />
                      ) : (
                        t("Confirm")
                      )}
                    </Button>
                    <Link to="/goals">
                      <Button
                        type="button"
                        color="secondary"
                        className="waves-effect btn-dark"
                        onClick={() => dispatch(resetGoal())}
                      >
                        {t("Cancel")}
                      </Button>
                    </Link>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewGoal);
